import React from "react";
import { formatCNPJ } from "../../utils/utilityFunctions";

const LASTRO_COMPANY_IDS: string[] = [
  // "41c755d8-aa00-468c-a40a-35677d463d12",
  // "8852dad2-8afa-4d87-969a-5ce5be9f013f",
];

interface LastroWarningProps {
  companyId: string | undefined;
  cnpj: string | undefined;
}

export const LastroWarning = ({ companyId, cnpj }: LastroWarningProps) => {
  if (!companyId || !LASTRO_COMPANY_IDS.includes(companyId)) return null;

  return (
    <div
      style={{
        backgroundColor: "#d32f2f",
        color: "white",
        padding: "20px",
        marginBottom: "24px",
        borderRadius: "8px",
        fontWeight: "bold",
        fontSize: "16px",
        border: "3px solid #b71c1c",
        boxShadow: "0 4px 12px rgba(211, 47, 47, 0.3)",
        lineHeight: "1.6",
      }}
    >
      <span role="img" aria-label="Aviso">
        ⚠️
      </span>{" "}
      AVISO IMPORTANTE: Foi verificado nos registros da CCEE que este agente -
      CNPJ {formatCNPJ(cnpj)} - possui uma insuficiência de lastro relevante,
      favor verificar o relatório PEN001
    </div>
  );
};
